import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "page-sign-in" }
const _hoisted_2 = { class: "main-content" }
const _hoisted_3 = { class: "login-button" }
const _hoisted_4 = { class: "login-button" }
const _hoisted_5 = ["href"]
const _hoisted_6 = /*#__PURE__*/_createElementVNode("img", {
  src: "/media/buttons/login-clever.svg",
  alt: "Login with Clever"
}, null, -1)
const _hoisted_7 = [
  _hoisted_6
]
const _hoisted_8 = { class: "login-button" }
const _hoisted_9 = ["href"]
const _hoisted_10 = /*#__PURE__*/_createElementVNode("img", {
  src: "/media/buttons/login-classlink.svg",
  alt: "Login with Classlink"
}, null, -1)
const _hoisted_11 = [
  _hoisted_10
]
const _hoisted_12 = /*#__PURE__*/_createElementVNode("div", { class: "arc-emblem" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: "/media/logos/arc-emblem-watermark.svg",
    class: "h-100 w-100"
  })
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("h1", null, _toDisplayString(_ctx.$t('pages.logout.header')), 1),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("img", {
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.loginArcId && _ctx.loginArcId(...args))),
          src: "/media/buttons/login-arcid.svg",
          alt: "Login with ARC ID"
        })
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("a", {
          class: "login-link",
          target: "_blank",
          href: $data.cleverSSOURL
        }, _hoisted_7, 8, _hoisted_5)
      ]),
      _createElementVNode("div", _hoisted_8, [
        _createElementVNode("a", {
          class: "login-link",
          target: "_blank",
          href: $data.classlinkSSOURL
        }, _hoisted_11, 8, _hoisted_9)
      ])
    ]),
    _hoisted_12
  ]))
}